import { Component, PropsWithChildren } from 'react';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = () =>
    createStyles({
        root: {
            position: 'sticky',
            top: 0,
            zIndex: 2,
        },
    });

type PoolStickyHeaderProps = WithStyles<typeof styles>;

export const PoolStickyHeader = withStyles(styles)(
    class PoolStickyHeaderBase extends Component<PropsWithChildren<PoolStickyHeaderProps>> {
        public override render() {
            return <div className={this.props.classes.root}>{this.props.children}</div>;
        }
    }
);
